import HTML5Backend from 'react-dnd-html5-backend';
import { DragDropContext} from 'react-dnd';

export function DNDWrapper(component){
    if(window.DNDContext === undefined){
        window.DNDContext = DragDropContext(HTML5Backend);   
    }
    return window.DNDContext(component);
}